'use client'

import { lazy } from 'react'

export const GlobalModalLazy = lazy(() => import('./Modal'))
